import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["tabindex", "id", "aria-expanded", "aria-owns", "aria-activedescendant", "aria-autocomplete", "disabled", "value", "defaultValue"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-selected", "id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_5 = ["aria-selected", "id", "onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", _mergeProps({
      type: "test",
      role: "combobox",
      class: { 'form-select': true, 'placeholder': _ctx.isLoading, },
      tabindex: _ctx.trueDisabled ? null : '0',
      onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
      id: _ctx.selectId,
      "aria-expanded": _ctx.expanded ? 'true' : 'false',
      "aria-owns": _ctx.$id('dropdown'),
      "aria-activedescendant": _ctx.activeDescendant,
      "aria-autocomplete": _ctx.autocomplete,
      ref: "select",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle())),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hide(), _ctx.interruptInlineCompletion()))
    }, _ctx.$attrs, {
      disabled: _ctx.trueDisabled,
      value: _ctx.inputValue,
      defaultValue: _ctx.isOption(_ctx.defaultValue) ? _ctx.trueOptionLabel(_ctx.defaultValue) : (_ctx.defaultValue != null ? '' + _ctx.defaultValue : ''),
      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }), null, 16, _hoisted_1),
    _createElementVNode("div", {
      id: _ctx.$id('dropdown'),
      class: "dropdown-menu start-0 customSelectDropdown",
      ref: "dropdown",
      role: "listbox",
      tabindex: "-1",
      onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        (_ctx.arbitrarySelection !== undefined)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              tabindex: "-1",
              class: _normalizeClass(["dropdown-item", {
            'active': _ctx.selectedIndex === undefined,
        }]),
              role: "option",
              "aria-selected": _ctx.selectedIndex === undefined ? 'true' : 'false',
              id: _ctx.$id('itemarbitrary'),
              onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.itemClick(undefined)))
            }, [
              _hoisted_4,
              _createTextVNode(_toDisplayString(_ctx.arbitrarySelection), 1)
            ], 42, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.filteredOptions !== _ctx.loadingPlaceholder)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.offeredOptions, (item, optionIndex) => {
              return (_openBlock(), _createElementBlock("button", {
                key: optionIndex,
                type: "button",
                tabindex: "-1",
                class: _normalizeClass(["dropdown-item", {
              'active': _ctx.selectedIndex === item.index,
          }]),
                role: "option",
                "aria-selected": _ctx.selectedIndex === item.index ? 'true' : 'false',
                id: _ctx.$id('item' + item.index),
                onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                onClick: ($event: any) => (_ctx.itemClick(item.index))
              }, [
                _hoisted_6,
                _renderSlot(_ctx.$slots, "option", {
                  option: item.option,
                  main: false
                }, () => [
                  _createTextVNode(_toDisplayString(_ctx.trueOptionLabel(item.option)), 1)
                ])
              ], 42, _hoisted_5))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ], 40, _hoisted_2)
  ], 64))
}